<template>
  <div>
    <div class="products-header">
      <div class="products-header-left">
        <div class="products-header-title">
          {{ title.name }} ({{ title.quantity }})
          <template v-if="rate && rate.quantity > 0">
            <div class="rate-and-review">
              <div>
                <span>
                  {{ rate.averageStars }}
                </span>
                <b-icon icon="star" />
              </div>
              <span>|</span>
              <span>
                {{ $tc('comments.reviewsCount', rate.quantity) }}
              </span>
            </div>
          </template>
        </div>
      </div>
      <div class="products-header-limit">
        <slot name="limit" />
      </div>
      <div class="products-header-pagination">
        <slot name="pagination" />
      </div>
    </div>
    <filter-tags :options="options" />
    <div class="products-container">
      <product-box v-for="product in products" :key="product.id" :product="product" />
    </div>
  </div>
</template>

<script>
import ProductBox from '~/marketplace-front-core/components/products/ProductBox'
import FilterTags from '~/marketplace-front-core/components/products/FilterTags'

export default {
  components: { ProductBox, FilterTags },
  props: {
    products: {
      type: Array,
      default () {
        return []
      }
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    title: {
      type: Object,
      default: null
    },
    rate: {
      type: Object,
      default: null
    }
  }
}
</script>
